import InputSelectComponent from './input-select/input-select';
import Input from './input';

export default Input;

export const InputSelect = InputSelectComponent;
